import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AttachmentType } from './attachment-type.model';
import * as AttachmentTypeActions from './attachment-type.actions';

export const attachmentTypesFeatureKey = 'attachmentTypes';

export interface State extends EntityState<AttachmentType> {
  // additional entities state properties
}

export const adapter: EntityAdapter<AttachmentType> = createEntityAdapter<AttachmentType>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(AttachmentTypeActions.addAttachmentType,
    (state, action) => adapter.addOne(action.attachmentType, state)
  ),
  on(AttachmentTypeActions.upsertAttachmentType,
    (state, action) => adapter.upsertOne(action.attachmentType, state)
  ),
  on(AttachmentTypeActions.addAttachmentTypes,
    (state, action) => adapter.addMany(action.attachmentTypes, state)
  ),
  on(AttachmentTypeActions.upsertAttachmentTypes,
    (state, action) => adapter.upsertMany(action.attachmentTypes, state)
  ),
  on(AttachmentTypeActions.updateAttachmentType,
    (state, action) => adapter.updateOne(action.attachmentType, state)
  ),
  on(AttachmentTypeActions.updateAttachmentTypes,
    (state, action) => adapter.updateMany(action.attachmentTypes, state)
  ),
  on(AttachmentTypeActions.deleteAttachmentType,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(AttachmentTypeActions.deleteAttachmentTypes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(AttachmentTypeActions.loadAttachmentTypes,
    (state, action) => adapter.setAll(action.attachmentTypes, state)
  ),
  on(AttachmentTypeActions.clearAttachmentTypes,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
